import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { InkoopOntvangstModalPage } from '../ontvangst-modal/ontvangst-modal.page';
import { ToastController } from '@ionic/angular';

import { AlertController, ModalController } from '@ionic/angular';

import { AjaxService } from '../ajax.service';
import { GlobalService } from '../global.service';
import { ScanCameraPage } from '../scan-camera/scan-camera.page';
import { I18nService } from '../shared/i18n.service';
import { CameraService } from '../camera.service';
import { OverlayEventDetail } from '@ionic/core';

@Component({
    selector: 'app-inkoop',
    templateUrl: './te-ontvangen.page.html',
    styleUrls: ['./te-ontvangen.page.scss'],
    standalone: false,
})
export class InkoopPage implements OnInit {
    public records: any[] = [];
    public headers: string[] = [];
    public groupedRecords: {
        POlev: string;
        purchases: {
            POLorder: string;
            records: any[];
        }[];
    }[] = [];
    public isLoading = true;
    public errorMessage: string = '';
    public currentFilter: string = '';
    scanCamera = false;

    constructor(
        public router: Router,
        public global: GlobalService,
        public alertController: AlertController,
        public http: HttpClient,
        public modalController: ModalController,
        private ajax: AjaxService,
        public i18n: I18nService,
        private camera: CameraService,
        private toastCtrl: ToastController
    ) {}

    ngOnInit() {
        if (!this.global.isLoggedIn) {
            this.router.navigateByUrl('login');
        }
    }

    ionViewWillEnter() {
        if (this.global.isLoggedIn) {
            this.loadData();
        }
    }

    loadData(filter: string = '') {
        this.isLoading = true;
        this.errorMessage = '';
        const params: any = {};
        if (filter) {
            params.search = filter;
        }
        this.ajax
            // .get('getInkoopTeOntvangen', params) // * old stuff to recover only non receivingn items. Used by app version V.3.4.23
            .get('getInkoopLijst', params)
            .then((data: any) => {
                this.isLoading = false;
                if (!data.login) {
                    this.router.navigateByUrl('login');
                } else {
                    this.records = data.records;
                    this.headers = data.header;
                    this.groupRecords();
                    if (!this.records || this.records.length === 0) {
                        this.errorMessage = 'No items to receive.';
                    }
                }
            })
            .catch((err: any) => {
                this.isLoading = false;
                this.errorMessage = 'Error retrieving data'; //? later will use this, for dev we need the ful info
                // this.errorMessage = err;
                // this.errorMessage = JSON.stringify(err, null, 2);
                console.error(err);
            });
    }

    handleSearch(event: any) {
        const query = event.target.value.toLowerCase();
        this.currentFilter = query;
        this.loadData(query);
    }

    doRefresh(event: any) {
        this.loadData();
        setTimeout(() => {
            event.target.complete();
        }, 1000);
    }

    groupRecords() {
        if (!this.records) {
            this.groupedRecords = [];
            return;
        }
        // ? grouped by leverancier
        const companyGroups = this.records.reduce((acc: any, record: any) => {
            const key = record.POlev;
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(record);
            return acc;
        }, {} as { [key: string]: any[] });

        this.groupedRecords = Object.keys(companyGroups).map((companyKey) => {
            const recordsForCompany = companyGroups[companyKey];

            // ? another grouping by POLorderf
            const orderGroups = recordsForCompany.reduce(
                (acc: any, record: any) => {
                    const orderKey = record.POLorder;
                    if (!acc[orderKey]) {
                        acc[orderKey] = [];
                    }
                    acc[orderKey].push(record);
                    return acc;
                },
                {} as { [key: string]: any[] }
            );

            const purchases = Object.keys(orderGroups).map((orderKey) => ({
                POLorder: orderKey,
                records: orderGroups[orderKey],
            }));
            return {
                POlev: companyKey,
                purchases: purchases,
            };
        });
    }

    async markPurchaseAsDone(inkoopNr: string) {
        const alert = await this.alertController.create({
            header: this.i18n.tr('Actie bevestigen'),
            message:
                this.i18n.tr('Alle artikelen in Ink. Nr: ') +
                inkoopNr + ' ' +
                this.i18n.tr('als ontvangen markeren?'),
            buttons: [
                {
                    text: this.i18n.tr('Annuleren'),
                    role: 'cancel',
                },
                {
                    text: this.i18n.tr('Bevestigen'),
                    handler: () => {
                        this.ajax
                            .get('setAllesGeleverd', {
                                inkoopNr: inkoopNr,
                                username: this.global.username,
                            })
                            .then(() => {
                                this.presentToast(
                                    inkoopNr +
                                        ' ' +
                                        this.i18n.tr(
                                            `als voltooid gemarkeerd.`
                                        ),
                                    'success'
                                );
                                this.loadData();
                            })
                            .catch((err) => {
                                this.presentToast(
                                    this.i18n.tr(
                                        'Er is een fout opgetreden bij het bijwerken van de inkoop.'
                                    ),
                                    'danger'
                                );
                                console.log(`Error: ${err}`);
                            });
                    },
                },
            ],
        });

        await alert.present();
    }

    public hasItemsToReceive(purchase: any): boolean {
        if (!purchase || !purchase.records) {
            return false;
        }
        return purchase.records.some((r: any) => r.sort_group == 1);
    }

    toggleGroup(group: any) {
        group.isExpanded = !group.isExpanded;
    }

    async openOntvangstModal(record: any) {
        const modal = await this.modalController.create({
            component: InkoopOntvangstModalPage,
            componentProps: {
                id: record.ID,
            },
        });
        modal.onDidDismiss().then((result) => {
            if (result.data && result.data.updated) {
                this.loadData(this.currentFilter);
            }
        });
        return await modal.present();
    }

    async presentToast(message: string, color: string) {
        const toast = await this.toastCtrl.create({
            message,
            duration: 3000,
            color,
            position: 'bottom',
        });
        toast.present();
    }

    async doScan() {
        if (!(await this.camera.startCamera())) {
            return;
        }
        this.scanCamera = true;
        const myDlg = await this.modalController.create({
            component: ScanCameraPage,
        });
        myDlg.onDidDismiss().then((dataPar: OverlayEventDetail) => {
            this.scanCamera = false;
            if (dataPar.data.code) {
                this.currentFilter = dataPar.data.code;
                this.loadData(this.currentFilter);
            }
        });
        return await myDlg.present();
    }
}
